/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_Program_AudioInputs */

const en_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program Audio`)
};

const fr_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio du programme`)
};

const de_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm-Audio`)
};

const it_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio del programma`)
};

const ru_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программное аудио`)
};

const es_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa de audio`)
};

const zh_cn2_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节目音频`)
};

const ja_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムオーディオ`)
};

const hi_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम ऑडियो`)
};

const pt_pt2_audio_description_export_loudness_program_audio = /** @type {(inputs: Audio_Description_Export_Loudness_Program_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áudio do programa`)
};

/**
* | output |
* | --- |
* | "Program Audio" |
*
* @param {Audio_Description_Export_Loudness_Program_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_program_audio = /** @type {((inputs?: Audio_Description_Export_Loudness_Program_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_Program_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_program_audio(inputs)
	if (locale === "de") return de_audio_description_export_loudness_program_audio(inputs)
	if (locale === "it") return it_audio_description_export_loudness_program_audio(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_program_audio(inputs)
	if (locale === "es") return es_audio_description_export_loudness_program_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_program_audio(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_program_audio(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_program_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_program_audio(inputs)
	return en_audio_description_export_loudness_program_audio(inputs)
});